import FooterInformation from './FooterInformation/FrooterInformation'
import './footer.sass'

const Footer = ({ footer }) => {
  const { 
    brandName,
    logo,
    links,
    socialLinks
  } = footer;

  return(
    <div className='footer-content-wrapper'>
      <div className='footer-content'>
        <section className='footer-section' style={{ backgroundImage: `url('https://cdn.homierent.com/strapi-media/bg_footer_d7b01860b0.svg')`}}>
        <div className='footer-section-content'>
          <footer className='footer-wrapper'>
            <FooterInformation
              brandName={brandName}
              logo={logo}
              links={links}
              socialLinks={socialLinks}
            />
          </footer>
        </div>
        </section>
      </div>
    </div>
  )
}

export default Footer
